<template>
  <KDialog v-model="open" title="Nouvelle tâche" icon="mdi-check-circle-outline" :max-width="680" fullscreen-on-mobile>
    <TaskForm v-if="open && userInfo" :userInfo="userInfo" @created="onCreated" @cancel="closeDialog" />
  </KDialog>
</template>

<script>
import KDialog from "@/components/ui/KDialog";
import TaskForm from "@/components/modules/@tasks/TaskForm";

export default {
  name: "ComponentTaskAddDialog",
  props: {
    userInfo: {
      type: Object,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    refreshTasks: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "init"],
  components: {
    KDialog,
    TaskForm,
  },
  computed: {
    open: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    closeDialog() {
      this.open = false;
    },
    onCreated() {
      this.$emit("init");
      this.closeDialog();
    },
  },
};
</script>
